<div class="sin-registros text-center" style="margin-top: 40px;margin-bottom: 40px;">
    <div class="fs-15">
        <ng-container *ngIf="spin; else empty"><span><i class="fa-solid fa-spinner fa-spin-pulse color-gray fs-30"></i></span></ng-container>
        <ng-template #empty><span>
            <p><i class="fa-light fa-empty-set fs-30 color-gray"></i></p>
            <p>{{ text }}</p>
        </span>
        </ng-template>
    </div>
</div>